module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/008_Preface#fm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Compass: A Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("I")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter01#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Diver Beneath the Street")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Dancing Princesses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Reintegration")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Fungi Moves")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Michigan Murders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Viral Crime")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Coventry Street, Detroit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Tree Trimming on Roosevelt Street")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Orderly Street Ghost")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Night Crawlers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Linnhurst, Between Gratiot and Chambers, Detroit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Candy Cane Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Foundation Ore")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("III")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Tunnels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Night Dive")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Witch Spring, Isolation Day Nine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Skin Thirst")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Membrane")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Welcome to Your Viral Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Dear White Pine in My Garden")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Travel Edges: Lunch time, Costanoa, Cascade Café,")]), _vm._v(" "), _c('strong', [_vm._v("Pacific Coast, California")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Desert Song")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Isolation/Skinner Releasing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Book Lungs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Moon Map in My Ypsilanti Backyard, in the Afternoon Thunderstorm")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Ghost Bridge of Ford Lake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Earth Séance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Turtle Disco")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Starship over Eastern Michigan University")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Tree Futures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Split/Screen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Gothic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Eventide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Princess, the Frog, and Iron Heinrich")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Diver Revisited")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bmt"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Notes#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Gratute#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Gratitude")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Ack#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Biblio#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Aboutauthor#bm-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0999ad29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0